export class QrefDokt4936Model {
  code: string;
  name: string;

  constructor() {
  }
}

